import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import NoticeInfo from './NoticeInfo';

const Notice = (props) => {
  const { data } = props;

  const history = useHistory();

  function clickDetailsFn(index) {
    window.open('/notice/details/' + data[index].noticeId, '_blank');
  }

  return (
    <TopLevelWrapper>
      <TotalView>
        {
          data.map((data, index) => (
            <NoticeInfo key={index} data={data} index={index} clickFn={clickDetailsFn}/>
          ))
        }
      </TotalView>
    </TopLevelWrapper>
  )
}

export default Notice;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;
  
  width: calc(100% - 10px);

  transition: all 0.3s ease-in-out;
`;

const TotalView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 100%;
`;
